import React, { createContext, useContext, useState } from 'react';
// Context
const MainContentSectionWidthContext = createContext(null);
// Provider Component
const MainContentSectionWidthContextProvider = ({ children }) => {
    const [mainContentSectionWidth, setMainContentSectionWidth] = useState(0);
    // Render
    return (React.createElement(MainContentSectionWidthContext.Provider, { value: {
            mainContentSectionWidth,
            setMainContentSectionWidth
        } }, children));
};
// Custom Hook
export const useMainContentSectionWidth = () => useContext(MainContentSectionWidthContext);
export default MainContentSectionWidthContextProvider;
